import React from 'react';
import FarmForm from '../forms/FarmForm';

const CreateFarmPage = () => {
  return <FarmForm mode="add" offset={1} span={11} />;
};

export default CreateFarmPage;
